import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BrowserQRCodeSvgWriter } from '@zxing/browser';
import { Subject } from 'rxjs';
import { User } from 'src/app/core/models/user';
import { VirtualAccountBalanceModel } from 'src/app/core/models/virtual-account-balance.model';
import { IdentityService } from 'src/app/core/services/identity.service';
import { environment } from 'src/environments/environment';
import { BalanceService } from '../../core/services/balance.service';
import { PaymentsService } from '../../core/services/payments.service';
import { ListTableComponent } from '../../shared/components/list-table/list-table.component';
import { headersTable } from '../../shared/interfaces/headers';
import * as svg from 'save-svg-as-png';
import { BranchOfficeModel } from 'src/app/core/models/branch-office.model';
import * as CryptoJS from 'crypto-js';
import { RolesWeb } from 'src/app/core/enums/roles.enum';

interface SimpleSelect {
  value: number;
  display: string;
}

interface HideInterface {
  id: number;
  value: boolean;
}

interface AccountInfo {
  alias: string;
  cbu: string;
  ingresoRapipago: boolean;
  tipoCuenta: string;
}

@Component({
  selector: 'app-account-yacare',
  templateUrl: './account-yacare.component.html',
  styleUrls: ['./account-yacare.component.scss']
})
export class AccountYacareComponent implements OnInit {
  readonly DATE_TYPES = {
    FROM: 'FROM',
    TO: 'TO'
  };

  readonly QUERY_TYPE = {
    NONE: 'NONE',
    AVAILABLES: 'AVAILABLES',
    TO_COLLECT: 'TO_COLLECT'
  };

  readonly MIN_LENGTH: number = 1;
  readonly DEFAULT_DEBOUNCE_TIME: number = 1000;
  readonly TO_MILISECONDS = 1000;
  readonly TIME_TO_REFRESH: number = environment.throttledRefreshBalance;
  readonly ENCRYPT_KEY: string = environment.encryptKey;

  @ViewChild('inputFrom') inputFrom: ElementRef;
  @ViewChild('inputTo') inputTo: ElementRef;
  @ViewChild(ListTableComponent) appTable: ListTableComponent;
  @ViewChild('inputFindElement') inputFindElement: ElementRef;
  @ViewChild('userQRCont', { static: true }) userQRCont: ElementRef;

  //#region TABLE DECLARATIONS
  qrGenerator: BrowserQRCodeSvgWriter;
  columnsCollection: headersTable[];
  selectedPaymentStates: string[];
  selectedMovementType: string = this.QUERY_TYPE.NONE;

  // @Events

  inputFindEventHandler: Subject<string>;

  // @Filtering Fields
  expandSearch: boolean = false;
  filter: string;
  filterDateFrom: Date;
  filterDateTo: Date;
  generalBalance: number = 0;
  balance: number = 0;
  balanceToCollect: number = 0;
  balances: VirtualAccountBalanceModel = new VirtualAccountBalanceModel();
  loggedUser: User;
  isCommerce: boolean = false;
  isValidate: boolean = false;
  isResponsible: boolean = false;
  disabledButtonRefresh: boolean = false;
  contador: number;
  countBranches = 0;
  branchOfficesCollection: SimpleSelect[];

  officeBranches: BranchOfficeModel[];

  isVisible: boolean = true;

  public QRimgSrc: string = '';

  get isPartialQuery(): boolean {
    return this.selectedMovementType != this.QUERY_TYPE.NONE;
  }

  get loggedUserIsResponsible(): boolean {
    return this.identityService.hasRolId(RolesWeb.RESPONSABLE);
  }

  loading = true;

  constructor(
    private translateService: TranslateService,
    private balanceService: BalanceService,
    private paymentsService: PaymentsService,
    private router: Router,
    private identityService: IdentityService
  ) {
    this.columnsCollection = new Array<headersTable>();
    this.selectedPaymentStates = new Array<string>();
    this.inputFindEventHandler = new Subject();
    this.branchOfficesCollection = new Array<SimpleSelect>();
    this.qrGenerator = new BrowserQRCodeSvgWriter();
  }

  //#region INITIALIZE COMPONENTS
  nombre: string = 'Bienvenido'; //Texto default
  isGenerated: boolean = false;
  bankInfo;

  async ngOnInit() {
    await this.refreshBalance();
    this.initHidenState(this.identityService.getUserID());
    // this.hideBalances();
    this.isCommerce = this.identityService.isCommerce();
    this.isResponsible = this.identityService.isRolResponsible();
    this.isValidate = this.identityService.getUserValidity();

    this.nombre = this.isCommerce
      ? this.identityService.getUser()?.organismo.nombre
      : this.identityService.getUser()?.persona.nombres + ' ' + this.identityService.getUser()?.persona.apellido;

    this.loggedUser = this.identityService.getUser();

    try {
      await this.loadInfo();
    } catch (error) {
      this.isGenerated = false;
    }
  }

  initHidenState(userId: number) {
    if (localStorage.getItem('hide')) {
      let ob = this.decryptItem('hide');
      if (ob && ob.id !== userId) {
        localStorage.removeItem('hide');
        this.createHidenState(userId);
      } else if (ob && ob.value) {
        this.isVisible = ob.value;
      } else {
        this.createHidenState(userId);
      }
    } else {
      this.createHidenState(userId);
    }
  }

  createHidenState(id: number) {
    let ob = { id, value: false };
    this.isVisible = ob.value;
    this.encryptItem('hide', ob);
  }

  encryptItem(name: string, object: any) {
    let codeEncrypted = CryptoJS.AES.encrypt(JSON.stringify(object).toString(), this.ENCRYPT_KEY).toString();
    localStorage.setItem(name, codeEncrypted);
  }

  decryptItem(item: string) {
    const codeEncrypted = localStorage.getItem(item);
    if (!codeEncrypted) {
      return null;
    }

    const codeBytes = CryptoJS.AES.decrypt(codeEncrypted, this.ENCRYPT_KEY);
    const decrypted = codeBytes.toString(CryptoJS.enc.Utf8);
    if (!decrypted) {
      return null;
    }

    return JSON.parse(decrypted);
  }

  hideBalances() {
    this.isVisible = !this.isVisible;
    let ob = this.decryptItem('hide');
    ob.value = this.isVisible;
    this.encryptItem('hide', ob);

    if (!this.isVisible && this.balances) {
      this.balances.generalBalance = 0.0;
      this.balances.availableBalance = 0.0;
      this.balances.toCollectBalance = 0.0;
    } else {
      this.balances.generalBalance = JSON.parse(localStorage.getItem('balances'))?.generalBalance;
      this.balances.availableBalance = JSON.parse(localStorage.getItem('balances'))?.availableBalance;
      this.balances.toCollectBalance = JSON.parse(localStorage.getItem('balances'))?.toCollectBalance;
    }
  }

  async generateQR(sucursalId: number = 0) {
    document.getElementById('userQR').innerHTML = '';
    const qrResponse = sessionStorage.getItem('qr-p')
      ? sessionStorage.getItem('qr-p')
      : await this.paymentsService.getQREMVco(sucursalId);
    sessionStorage.setItem('qr-p', qrResponse);
    if (qrResponse) {
      if (sessionStorage.getItem('qr-src')) {
        this.qrGenerator.writeToDom('#userQR', qrResponse, 380, 380);
        this.QRimgSrc = sessionStorage.getItem('qr-src');
      } else {
        this.qrGenerator.writeToDom('#userQR', qrResponse, 380, 380);
        this.QRimgSrc = await svg.svgAsPngUri(this.userQRCont.nativeElement.children[0], { backgroundColor: 'white' });
        sessionStorage.setItem('qr-src', this.QRimgSrc);
      }
    }
  }

  async handleClick(): Promise<void> {
    this.balances = await this.balanceService.getVirtualAccountBalance();
    localStorage.setItem('balances', JSON.stringify(this.balances));
  }

  async loadInfo(): Promise<void> {
    if (!localStorage.getItem('bankInfo')) {
      const bankInfo = <AccountInfo>await this.balanceService.cashIn();
      this.bankInfo = bankInfo;
      this.isGenerated = this.bankInfo.cbu !== '' ? true : false;
      localStorage.setItem('bankInfo', JSON.stringify(bankInfo));
    } else {
      this.bankInfo = JSON.parse(localStorage.getItem('bankInfo'));
    }
  }

  async getBalanceAndSave(): Promise<void> {
    const account = await this.balanceService.getVirtualAccountBalance();
    this.balances = account;
    localStorage.setItem('balances', JSON.stringify(this.balances));
  }

  async refreshBalance(): Promise<void> {
    !localStorage.getItem('balances')
      ? this.getBalanceAndSave()
      : (this.balances = JSON.parse(localStorage.getItem('balances')));
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }

  goToCvuView(url: string) {
    let currentUrl = this.router.url;
    localStorage.setItem('url', currentUrl);
    this.navigate(url);
  }

  goToQr(url: string) {
    let currentUrl = this.router.url;
    localStorage.setItem('url', currentUrl);
    this.navigate(url);
  }

  navigate(url: string) {
    this.router.navigate([url]);
  }

  goToMovements() {
    const paymentMethods = [30, 42];
    const paymentStates = [2, 3];
    const queryParams = {
      paymentMethod: paymentMethods,
      paymentState: paymentStates,
      page: '1'
    };
    const navigationExtras: NavigationExtras = {
      queryParams: queryParams,
      queryParamsHandling: 'merge',
      skipLocationChange: false,
      replaceUrl: false
    };
    this.router.navigate(['/user/movements'], navigationExtras);
  }
  goToSchedule() {
    this.router.navigate(['/user/balance-schedule']);
  }
}
